import React,  { useState, useEffect } from "react"
import axios from 'axios';
import DefaultTemplate from "../templates/DefaultTemplate";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import AlertDialog from "../templates/AlertDialog";

const Entries = () => {
    // process
    const [data, setData] = useState({ entries: [] });
    const [dialogData, setDialogData] = useState({isOpen:false, title:"error", message: ""});
    const fetchList = async () => {
        try{
            const result =await axios.get(process.env.REACT_APP_DOBLOG_BACKEND_PATH + 'manager/api/getAllEntries');
            setData(result.data);
        }catch(error){
            setData({entries: []});
            console.log(error.response.status);
            // 401 Unauthorizedならbackendのrootに遷移
            if(error.response.status === 401){
              window.location.href = process.env.REACT_APP_DOBLOG_BACKEND_PATH;
              return;
            }
            setDialogData({isOpen:true, title:"Error", message: error.response.status + " " + error.response.statusText});
        }
    };
    useEffect(() => {
        fetchList();
    }, []);
    // table
    const StyledTableCell = withStyles((theme) => ({
        head: {
          backgroundColor: theme.palette.common.black,
          color: theme.palette.common.white,
        },
        /*body: {
          fontSize: "1rem",
        },*/
    }))(TableCell);
    const StyledTableRow = withStyles((theme) => ({
        root: {
          '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.selected,
          },
          '&:hover':{
            backgroundColor:"#1d57b1",
          }
        }
      }))(TableRow);
    const useStyles = makeStyles({
        table: {
          minWidth: 700,
        },
        publishDate:{
          whiteSpace:"nowrap",
        },
        published:{
            color:"#0f0",
            whiteSpace:"nowrap",
        },
        notPublished:{
            color:"#f00",
            whiteSpace:"nowrap",
        },
      });
    const classes = useStyles();
    // render
    return(
        <DefaultTemplate title="Entries">
            <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="customized table">
                <TableHead>
                <TableRow>
                    <StyledTableCell>ID</StyledTableCell>
                    <StyledTableCell>公開日</StyledTableCell>
                    <StyledTableCell>Title</StyledTableCell>
                    <StyledTableCell>Entry Code</StyledTableCell>
                    <StyledTableCell>Category</StyledTableCell>
                    <StyledTableCell>状態</StyledTableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {data.entries.map((row) => (
                    <StyledTableRow key={row.id} onClick={() => window.location.href = "/entries/edit/" + row.entryId}>
                    <StyledTableCell /*component="th" scope="row"*/>{row.entryId}</StyledTableCell>
                    <StyledTableCell className={classes.publishDate}>{row.publishDate}</StyledTableCell>
                    <StyledTableCell>{row.title}</StyledTableCell>
                    <StyledTableCell>{row.entryCode}</StyledTableCell>
                    <StyledTableCell>{/*row.category.map(str => {return(<p>{str}</p>)})*/row.category.join(", ")}</StyledTableCell>
                    <StyledTableCell className={(row.isPublished === 1) ? classes.published : classes.notPublished}>{(row.isPublished === 1) ? "公開中" : "非公開"}</StyledTableCell>
                    </StyledTableRow>
                ))}
                </TableBody>
            </Table>
            </TableContainer>
            <AlertDialog isOpen={dialogData.isOpen} title={dialogData.title} message={dialogData.message} />
        </DefaultTemplate>
    )
}

export default Entries;